import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Rol,
  TextArea
} from '@app/shared';

@Injectable()
export class ManagementGroupsFormsService {
  constructor() { }

  /**
   * Retorna el formulario de creacion o edicion de roles(grupos) en el sistema
   *
   * @param {Rol} [rol]
   * @returns {BaseControl<any>[]}
   * @memberof ManagementGroupsFormsService
   */
  getFormRol(rol?: Rol): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtNombre',
        value: rol ? rol.nombre ? rol.nombre : null : null,
        label: 'Nombre del grupo',
        placeholder: 'Ingrese el nombre del grupo',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new TextArea({
        key: 'txtDescripcion',
        value: rol ? rol.descripcion ? rol.descripcion : null : null,
        label: 'Descripción',
        placeholder: 'Ingrese una brebe descripción del grupo',
        rows: '4',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'chActivo',
        type: 'checkbox',
        value: rol ? rol.activo ? rol.activo : true : true,
        label: 'Activo',
        order: 3,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups/shared/management-groups.form.service.ts